import React from "react";

const ChatMessage = ({ message }) => {
  const isUser = message.role === "user";

  if (isUser) {
    return (
      <div className="flex justify-end">
        <div className="max-w-[80%] bg-emerald-600 text-white px-4 py-2.5 rounded-2xl rounded-br-md text-sm">
          {message.content}
        </div>
      </div>
    );
  }

  // Assistant message
  if (message.streaming && !message.content) {
    return (
      <div className="flex justify-start">
        <div className="bg-white border border-slate-200 px-4 py-3 rounded-2xl rounded-bl-md">
          <div className="dot-pulse flex gap-1">
            <span className="w-2 h-2 bg-emerald-500 rounded-full inline-block"></span>
            <span className="w-2 h-2 bg-emerald-500 rounded-full inline-block"></span>
            <span className="w-2 h-2 bg-emerald-500 rounded-full inline-block"></span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start">
      <div className="max-w-[90%] bg-white border border-slate-200 px-4 py-3 rounded-2xl rounded-bl-md text-sm text-slate-800 leading-relaxed">
        <div
          className="chat-content"
          dangerouslySetInnerHTML={{ __html: formatContent(message.content) }}
        />
      </div>
    </div>
  );
};

// Convert markdown-like content to HTML
function formatContent(text) {
  if (!text) return "";

  // If it already looks like HTML (starts with <), return as-is
  if (text.trim().startsWith("<")) {
    return text;
  }

  let html = text;

  // Headers
  html = html.replace(/^### (.+)$/gm, '<h3 class="text-base font-semibold text-slate-800 mt-4 mb-2">$1</h3>');
  html = html.replace(/^## (.+)$/gm, '<h2 class="text-lg font-semibold text-slate-800 mt-4 mb-2">$1</h2>');

  // Bold
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // Tables
  html = html.replace(/^\|(.+)\|$/gm, (match) => {
    const cells = match.split("|").filter(Boolean).map((c) => c.trim());
    const isHeader = cells.every((c) => /^[-:]+$/.test(c));
    if (isHeader) return ""; // skip separator row
    const tag = "td";
    const row = cells.map((c) => `<${tag} class="px-3 py-2 border-b border-slate-100 text-xs">${c}</${tag}>`).join("");
    return `<tr>${row}</tr>`;
  });
  // Wrap consecutive <tr> in table
  html = html.replace(/((<tr>.*<\/tr>\s*)+)/g, '<div class="overflow-x-auto my-3"><table class="w-full border-collapse text-left"><tbody>$1</tbody></table></div>');

  // Bullet points
  html = html.replace(/^- (.+)$/gm, '<li class="ml-4 text-sm text-slate-700">$1</li>');
  html = html.replace(/((<li.*<\/li>\s*)+)/g, '<ul class="list-disc space-y-1 my-2">$1</ul>');

  // Horizontal rules
  html = html.replace(/^---$/gm, '<hr class="my-3 border-slate-200" />');

  // Line breaks
  html = html.replace(/\n/g, "<br />");

  return html;
}

export default ChatMessage;
